import React from 'react';
import { Row } from '../../lib/utils';
import { Body1Regular, Body3Bold, Body3Light, Body3Regular, CaptionLight, Head4 } from '../../lib/font';
import { colors } from '../../lib/colors';
import SmallButton from '../Button/SmallButton';
import dayjs from 'dayjs';
import SortTypeDropDown from '../DropDown/SortTypeDropDown';
import WhiteRoundButton from '../Button/WhiteRoundButton';
import RoundedDropDown from '../DropDown/RoundedDropDown';
import ResetButton from '../Button/ResetButton';

type Props = {
    sortOptions: any;
    sortType: any;
    isVisibleSort: boolean;
    toggleDropDown: () => void;
    handleDropDownSelect: (option: any) => void;
    onClickCalendar: () => void;
    onClickRefresh: () => void;
    startDate: any;
    endDate: any;
    onClickClearFilter: () => void;
    viewMode?: 'card' | 'table';
    onToggleViewMode?: () => void;
};

const FeedMemberHeader = ({
    sortOptions,
    sortType,
    isVisibleSort,
    toggleDropDown,
    handleDropDownSelect,
    onClickCalendar,
    onClickRefresh,
    startDate,
    endDate,
    onClickClearFilter,
    viewMode = 'card',
    onToggleViewMode,
}: Props) => {
    return (
        <>
            <Row style={{ width: 397, justifyContent: 'space-between', alignItems: 'center', marginLeft: 8 }}>
                <Head4 style={{ color: colors.LAVEL_4 }}>{'수업 피드'}</Head4>
                <CaptionLight style={{ color: colors.LAVEL_2 }}>
                    {'강사님들과 회원님들이 남긴 모든 피드를 확인해보세요!'}
                </CaptionLight>
            </Row>
            <Row style={{ alignItems: 'center', marginTop: 32, justifyContent: 'space-between' }}>
                <Row style={{ width: 786, alignItems: 'center', justifyContent: 'space-between' }}>
                    <Row style={{ alignItems: 'center' }}>
                        {startDate && endDate ? (
                            <Body3Regular style={{ marginRight: 16 }}>
                                {dayjs(startDate).format('YYYY년 M월 D일 ~ ')}
                                {dayjs(endDate).format('YYYY년 M월 D일 ')}
                            </Body3Regular>
                        ) : (
                            <Body3Regular>{'전체 기간'}</Body3Regular>
                        )}

                        <WhiteRoundButton
                            customStyle={{ marginLeft: 16 }}
                            callBack={onClickCalendar}
                            text={'기간 선택'}
                            size="tiny"
                        />
                        <ResetButton style={{ marginLeft: 16 }} text={'초기화'} callBack={onClickClearFilter} />
                    </Row>

                    <Row style={{ alignItems: 'center' }}>
                        {/* 뷰 토글 버튼 */}
                        {onToggleViewMode && (
                            <div className="flex items-center bg-[#F1F5F9] rounded-[8px] p-[3px] mr-[16px]">
                                <button
                                    onClick={() => viewMode !== 'card' && onToggleViewMode()}
                                    className={`flex items-center justify-center w-[32px] h-[28px] rounded-[6px] transition-all cursor-pointer ${
                                        viewMode === 'card'
                                            ? 'bg-white shadow-sm text-[#374151]'
                                            : 'text-[#94A3B8] hover:text-[#64748B]'
                                    }`}
                                    title="카드 뷰"
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="3" width="7" height="7" rx="1"/>
                                        <rect x="14" y="3" width="7" height="7" rx="1"/>
                                        <rect x="3" y="14" width="7" height="7" rx="1"/>
                                        <rect x="14" y="14" width="7" height="7" rx="1"/>
                                    </svg>
                                </button>
                                <button
                                    onClick={() => viewMode !== 'table' && onToggleViewMode()}
                                    className={`flex items-center justify-center w-[32px] h-[28px] rounded-[6px] transition-all cursor-pointer ${
                                        viewMode === 'table'
                                            ? 'bg-white shadow-sm text-[#374151]'
                                            : 'text-[#94A3B8] hover:text-[#64748B]'
                                    }`}
                                    title="테이블 뷰"
                                >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="8" y1="6" x2="21" y2="6"/>
                                        <line x1="8" y1="12" x2="21" y2="12"/>
                                        <line x1="8" y1="18" x2="21" y2="18"/>
                                        <line x1="3" y1="6" x2="3.01" y2="6"/>
                                        <line x1="3" y1="12" x2="3.01" y2="12"/>
                                        <line x1="3" y1="18" x2="3.01" y2="18"/>
                                    </svg>
                                </button>
                            </div>
                        )}

                        <ResetButton text={'새로 고침'} callBack={onClickRefresh} />

                        <RoundedDropDown
                            toggleSortDropDown={toggleDropDown}
                            sortType={sortType}
                            isOpenSort={isVisibleSort}
                            sortOptions={sortOptions}
                            handleSortSelect={handleDropDownSelect}
                            size="small"
                        />
                    </Row>
                </Row>

                <Row style={{ width: 380, justifyContent: 'flex-end' }}>
                    <ResetButton text={'초기화'} callBack={onClickClearFilter} />
                </Row>
            </Row>
        </>
    );
};

export default FeedMemberHeader;
